module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "value-format": "timestamp",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "disabled": _vm.form.is_forever,
      "default-time": ['00:00:00', '23:59:59'],
      "picker-options": _vm.pickerOptions2
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v("\n           \n        "), _c('el-checkbox', {
    model: {
      value: (_vm.form.is_forever),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_forever", $$v)
      },
      expression: "form.is_forever"
    }
  }, [_vm._v("长期有效")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠送方式"
    }
  }, [(_vm.form.activity_type === 'member_birthday') ? _c('el-radio-group', {
    model: {
      value: (_vm.condition),
      callback: function($$v) {
        _vm.condition = $$v
      },
      expression: "condition"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "birthday_month"
    }
  }, [_vm._v("生日当月1日统一发放")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "birthday_week"
    }
  }, [_vm._v("生日当周周日统一发放")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "birthday_day"
    }
  }, [_vm._v("生日当日统一发放")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_upgrade') ? _c('el-radio', {
    attrs: {
      "label": "member_upgrade"
    },
    model: {
      value: (_vm.condition),
      callback: function($$v) {
        _vm.condition = $$v
      },
      expression: "condition"
    }
  }, [_vm._v("会员升级成功后发放")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_vip_upgrade') ? _c('el-radio', {
    attrs: {
      "label": "member_vip_upgrade"
    },
    model: {
      value: (_vm.condition),
      callback: function($$v) {
        _vm.condition = $$v
      },
      expression: "condition"
    }
  }, [_vm._v("付费会员升级成功后发放")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_anniversary') ? _c('el-radio-group', {
    model: {
      value: (_vm.condition),
      callback: function($$v) {
        _vm.condition = $$v
      },
      expression: "condition"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "anniversary_month"
    }
  }, [_vm._v("周年入会当月1日统一发放")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "anniversary_week"
    }
  }, [_vm._v("周年入会当周周日统一发放")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "anniversary_day"
    }
  }, [_vm._v("周年入会当日统一发放")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_day') ? _c('el-radio-group', {
    model: {
      value: (_vm.condition),
      callback: function($$v) {
        _vm.condition = $$v
      },
      expression: "condition"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "every_year"
    }
  }, [_vm._v("每年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "every_month"
    }
  }, [_vm._v("每月")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "every_week"
    }
  }, [_vm._v("每周")])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.condition === 'every_year') ? _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择月份"
    },
    model: {
      value: (_vm.memberDay.month),
      callback: function($$v) {
        _vm.$set(_vm.memberDay, "month", $$v)
      },
      expression: "memberDay.month"
    }
  }, _vm._l((_vm.monthOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.memberDay.day),
      callback: function($$v) {
        _vm.$set(_vm.memberDay, "day", $$v)
      },
      expression: "memberDay.day"
    }
  }, _vm._l((_vm.dayOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.condition === 'every_month') ? _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.memberDay.day),
      callback: function($$v) {
        _vm.$set(_vm.memberDay, "day", $$v)
      },
      expression: "memberDay.day"
    }
  }, _vm._l((_vm.dayOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.condition === 'every_week') ? _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择星期"
    },
    model: {
      value: (_vm.memberDay.week),
      callback: function($$v) {
        _vm.$set(_vm.memberDay, "week", $$v)
      },
      expression: "memberDay.week"
    }
  }, _vm._l((_vm.weekOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()])], 1), _vm._v(" "), _vm._l((_vm.levelData), function(levelItem) {
    return _c('el-form-item', {
      key: levelItem.grade_id,
      attrs: {
        "label": levelItem.grade_name + '优惠设置'
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_vm._l((_vm.coupons), function(item) {
      return (levelItem.grade_id === item.id) ? _c('el-col', {
        key: item.index,
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "promotion-card"
      }, [_c('div', {
        staticClass: "promotion-card-header"
      }, [_vm._v("\n                优惠券\n                "), _c('a', {
        staticClass: "promotion-card-btn",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.showModal('coupons', item.id)
          }
        }
      }, [_vm._v("新增")])]), _vm._v(" "), _c('div', {
        staticClass: "promotion-card-body"
      }, [_c('ul', {
        staticClass: "promotion-card-list"
      }, _vm._l((item.checked), function(child, index) {
        return _c('li', {
          key: index
        }, [_c('div', {
          staticClass: "promotion-name"
        }, [_vm._v("\n                      " + _vm._s(child.title) + "\n                    ")]), _vm._v(" "), _c('el-input-number', {
          attrs: {
            "size": "mini",
            "controls-position": "right",
            "min": 1,
            "max": 10,
            "label": "描述文字"
          },
          model: {
            value: (child.count),
            callback: function($$v) {
              _vm.$set(child, "count", $$v)
            },
            expression: "child.count"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "remove-btn el-icon-delete",
          on: {
            "click": function($event) {
              return _vm.removeChecked('coupons', index, item.id)
            }
          }
        })], 1)
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.goods), function(item) {
      return (levelItem.grade_id === item.id) ? _c('el-col', {
        key: item.index,
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "promotion-card"
      }, [_c('div', {
        staticClass: "promotion-card-header"
      }, [_vm._v("\n                商品\n                "), _c('a', {
        staticClass: "promotion-card-btn",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.showModal('goods', item.id)
          }
        }
      }, [_vm._v("新增")])]), _vm._v(" "), _c('div', {
        staticClass: "promotion-card-body"
      }, [_c('ul', {
        staticClass: "promotion-card-list"
      }, _vm._l((item.checked), function(child, index) {
        return _c('li', {
          key: index
        }, [_c('div', {
          staticClass: "promotion-name"
        }, [_vm._v("\n                      " + _vm._s(child.itemName) + "\n                    ")]), _vm._v(" "), _c('el-input-number', {
          attrs: {
            "size": "mini",
            "controls-position": "right",
            "min": 1,
            "max": 10,
            "label": "描述文字"
          },
          model: {
            value: (child.count),
            callback: function($$v) {
              _vm.$set(child, "count", $$v)
            },
            expression: "child.count"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "remove-btn el-icon-delete",
          on: {
            "click": function($event) {
              return _vm.removeChecked('goods', index, item.id)
            }
          }
        })], 1)
      }), 0)])])]) : _vm._e()
    })], 2)], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "短信通知"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.sms_isopen),
      callback: function($$v) {
        _vm.$set(_vm.form, "sms_isopen", $$v)
      },
      expression: "form.sms_isopen"
    }
  }), _vm._v("\n          请确保短信账户余额充足 "), _c('router-link', {
    attrs: {
      "to": {
        path: _vm.matchInternalRoute('datamessage')
      },
      "target": "_blank"
    }
  }, [_vm._v("查看短息账户")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.form.sms_isopen) ? _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [(_vm.form.activity_type === 'member_birthday') ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n              小程序名称\n              "), _c('el-input', {
    staticClass: "content-bottom-padded",
    attrs: {
      "placeholder": "请填写小程序名称"
    },
    model: {
      value: (_vm.form.sms_params.app_name),
      callback: function($$v) {
        _vm.$set(_vm.form.sms_params, "app_name", $$v)
      },
      expression: "form.sms_params.app_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    staticClass: "box-card sms-templ"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("短信模板")])]), _vm._v(" "), (_vm.form.activity_type === 'member_birthday') ? _c('span', [_vm._v("尊敬的会员：值此您生日之际，衷心祝您生日快乐！为感谢您对本店的支持，特此赠送您｛赠送内容｝｛数量｝。详情请查看官方小程序")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_day') ? _c('span', [_vm._v("｛会员日时间｝是｛品牌｝会员日，特此为您奉上｛奖品｝。到店更有其他惊喜")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_anniversary') ? _c('span', [_vm._v("历史上的今天，您成为了｛品牌｝会员。感谢您一路来对｛品牌｝的支持，特此为您奉上｛奖品｝。到店更有其他惊喜。")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_upgrade') ? _c('span', [_vm._v("恭喜您成为｛品牌｝｛会员等级名称｝，特此为您奉上｛奖品｝。到店更有其他惊喜。")]) : _vm._e(), _vm._v(" "), (_vm.form.activity_type === 'member_vip_upgrade') ? _c('span', [_vm._v("恭喜您成为" + _vm._s(_vm.品牌) + "的" + _vm._s(_vm.付费会员等级名称) + "，特此为您奉上" + _vm._s(_vm.赠送内容))]) : _vm._e()])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")])], 1)], 2)], 1), _vm._v(" "), _vm._l((_vm.levelData), function(levelItem) {
    return _c('div', _vm._l((_vm.goods), function(item, index) {
      return (levelItem.grade_id === item.id) ? _c('el-dialog', {
        key: index,
        attrs: {
          "title": "选择商品",
          "visible": item.dialog,
          "width": "30%"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(item, "dialog", $event)
          },
          "open": function($event) {
            return _vm.onshowModal('goods')
          },
          "close": function($event) {
            return _vm.oncloseModal('goods')
          }
        }
      }, [_c('ul', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (item.loading),
          expression: "item.loading"
        }],
        staticClass: "dialog-list clearfix"
      }, [_vm._l((item.list), function(child) {
        return [_c('li', {
          class: child.checked ? 'checked' : '',
          on: {
            "click": function($event) {
              return _vm.selectItems('goods', child)
            }
          }
        }, [(child.checked) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _vm._e(), _vm._v(" " + _vm._s(child.itemName))])]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "content-padded"
      }, [_c('el-pagination', {
        attrs: {
          "background": "",
          "layout": "prev, pager, next",
          "current-page": item.page.currentPage,
          "page-size": item.page.pageSize,
          "total": item.page.total
        },
        on: {
          "current-change": _vm.changeGoodsPage
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_vm._l((item.temp), function(child, index) {
        return [_c('li', [_vm._v(_vm._s(child.itemName))])]
      })], 2), _vm._v(" "), _c('span', {
        staticClass: "dialog-footer",
        attrs: {
          "slot": "footer"
        },
        slot: "footer"
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            return _vm.cancelSelected('goods')
          }
        }
      }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.submitSelected('goods')
          }
        }
      }, [_vm._v("确 定")])], 1)]) : _vm._e()
    }), 1)
  }), _vm._v(" "), _vm._l((_vm.levelData), function(levelItem) {
    return _c('div', _vm._l((_vm.coupons), function(item, index) {
      return (levelItem.grade_id === item.id) ? _c('el-dialog', {
        key: index,
        attrs: {
          "title": "选择优惠券",
          "visible": item.dialog,
          "width": "30%"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(item, "dialog", $event)
          },
          "open": function($event) {
            return _vm.onshowModal('coupons')
          },
          "close": function($event) {
            return _vm.oncloseModal('coupons')
          }
        }
      }, [_c('ul', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (item.loading),
          expression: "item.loading"
        }],
        staticClass: "dialog-list clearfix"
      }, [_vm._l((item.list), function(child) {
        return [_c('li', {
          class: child.checked ? 'checked' : '',
          on: {
            "click": function($event) {
              return _vm.selectItems('coupons', child)
            }
          }
        }, [(child.checked) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _vm._e(), _vm._v(" " + _vm._s(child.title))])]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "content-padded"
      }, [_c('el-pagination', {
        attrs: {
          "background": "",
          "layout": "prev, pager, next",
          "current-page": item.page.currentPage,
          "page-size": item.page.pageSize,
          "total": item.page.total
        },
        on: {
          "current-change": _vm.changeCouponsPage
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_vm._l((item.temp), function(child, index) {
        return [_c('li', [_vm._v(_vm._s(child.title))])]
      })], 2), _vm._v(" "), _c('span', {
        staticClass: "dialog-footer",
        attrs: {
          "slot": "footer"
        },
        slot: "footer"
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            return _vm.cancelSelected('coupons')
          }
        }
      }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.submitSelected('coupons')
          }
        }
      }, [_vm._v("确 定")])], 1)]) : _vm._e()
    }), 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("\n      创建营销活动\n    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55b74493", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b74493"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/activity/add.vue
// module id = 2725
// module chunks = 0